// Team.js
import { Link } from 'react-router-dom';
import React, { useState, useEffect } from "react";
import SectionHeading from "../Components/SectionHeading/SectionHeading";
import parser from "html-react-parser";
import { Helmet } from 'react-helmet-async';
import teamData from "../utils/teamdata";

export default function Team() {
  return (
    <>
    <Helmet>
      <title>Meet Our Expert Dental Team – Your Smile Specialists</title>
      <meta name="description" content="Meet our skilled dental team—trusted smile specialists offering expert, caring, and professional dental treatment in Bradford." />
    </Helmet>
      <div className="st-height-b125 st-height-lg-b80" id="home"></div>
      <div className="st-height-b60 st-height-lg-b60" />

      <SectionHeading
        title="Dentists & Staff"
        subTitle="We have a dedicated team consisting of highly skilled dentists and staff who works <br/> relentlessly to preserve your happy smile."
      />
      <div className="st-height-b60 st-height-lg-b60" />

      <div className="grid-class-4 container">
        {teamData.map((member, index) => (
          <Link to={`/team/${member.id}`} className="team-member-link" key={index}>
            <div
              className="team-member"
            >
              <img src={member.img} className="image-fluid" alt={member.name} />
              <h4>{member.name}</h4>
              <p>{parser(member.designation)}</p>
            </div>
          </Link>
        ))}
      </div>

      <div className="st-height-b120 st-height-lg-b80" />
      <style jsx>{`
        .team-member-link {
          text-decoration: none;
          color: inherit;
          display: block;
          transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
        }
        .team-member-link:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.08);
        }
        .team-member {
          text-align: center;
          padding-bottom: 15px;
        }
        .team-member img {
          width: 100%;
          border-radius: 5px;
          object-fit: cover;
          margin-bottom: 15px;
        }
        .team-member h4 {
          margin: 5px 0;
          color: #333;
          font-size: 18px;
        }
        .team-member p {
          color: #666;
          font-size: 14px;
          margin: 0;
        }
        @media (max-width: 768px) {
          .team-member {
            margin-bottom: 20px;
          }
        }
      `}</style>
    </>
  );
}